// Simple i18n messages
import { translations as landingTranslations } from '../translations';

const messages = {
  zh: {
    common: {
      clear: '清除',
      analyzing: '分析中...',
      copy: '复制',
      copied: '已复制',
    },
    login: {
      title: 'VGOT',
      welcomeBack: '欢迎回来',
      createAccount: '创建账号',
      username: '用户名',
      password: '密码',
      email: '邮箱',
      verificationCode: '验证码',
      inviteCode: '邀请码 (可选)',
      usernamePlaceholder: '请输入用户名',
      passwordPlaceholder: '请输入密码',
      emailPlaceholder: '请输入邮箱',
      verificationCodePlaceholder: '请输入验证码',
      inviteCodePlaceholder: '请输入邀请码（可不填）',
      sendCode: '发送验证码',
      sending: '发送中...',
      resendIn: '{sec}s后重发',
      loginButton: '登录',
      registerButton: '注册',
      loggingIn: '登录中...',
      registering: '注册中...',
      orDivider: '或',
      googleLogin: '使用 Google 登录',
      hasAccount: '已有账号？',
      noAccount: '还没有账号？',
      goToLogin: '去登录',
      goToRegister: '立即注册',
      codeSent: '验证码已发送至您的邮箱',
      registerSuccess: '注册成功！请登录',
    },
    landing: {
      loginBtn: '登录',
      title: 'VGOT实现优秀的内容创作',
      subtitle: '使用VGOT一起探索电商爆款视频制作，支持无水印高清SORA2视频制作，增强视频画质，爆款脚本分析，数字人制作等等...',
      loading: '加载中…',
    },
    sidebar: {
      workspace: '工作台',
      history: '生成记录',
      section: {
        replicator: '爆款复刻',
        commerce: '带货视频',
        finance: '财务与增长',
        account: '账号',
      },
      scripts: '脚本',
      digitalExpert: '数字专家',
  sora: 'HyperSell',
  superIP: 'Super IP',
      partner: '推广计划',
      subscription: '订阅计划',
      credits: '积分与算力',
      payment: '支付',
      referral: '推荐与计划',
      noEmail: '未绑定邮箱',
      logout: '退出',
      userMenu: {
        toggleLang: '切换语言',
        profile: '个人资料',
        settings: '设置',
        upgrade: '升级套餐',
        credits: '积分',
        freeplan: 'Free 套餐',
      },
    },
    videoAnalysis: {
      title: '数秒内获取视频洞察',
      subtitle: '选择分析目标，粘贴视频链接，快速获得可执行的洞察',
      uploadTitle: '拖拽或点击上传',
      uploadImageTitle: '拖拽或点击上传图片',
      uploadHint: '支持 MP4、MOV 等格式，推荐尺寸 720P+',
      chooseVideo: '选择视频',
      clearFile: '清除',
      securityHint: '视频将安全上传至服务器，仅用于提取提示词',
  urlLabel: '或粘贴视频链接（支持 TikTok 链接）',
  urlLabelBasic: '或粘贴视频链接',
      placeholder: 'https://www.tiktok.com/@nickname/video/7548476830056025374',
      optionsTitle: '分析选项',
  optionScriptTitle: '提取音频文案',
    optionSceneTitle: '反推提示词',
  optionRewriteTitle: '爆款文案',
  optionScriptDesc: '从视频中提取音频脚本文案',
  optionSceneDesc: '分析视频内容，一键反推提示词',
  optionRewriteDesc: '根据产品信息与产品图片一键生成爆款文案',
      startAnalyze: '开始分析',
      resultTitle: '分析结果',
      resultPlaceholder: '分析结果将显示在这里',
      
    },
    workspace: {
      title: '你好！今天想创作什么？',
      cards: {
        generateTitle: '生成视频',
  generateDesc: '生成视频，创造令人惊艳的作品',
        analyzeTitle: '分析视频',
        analyzeDesc: '快速获取视频的脚本灵感，聊天探索更多创意',
        digitalTitle: 'Super IP',
        digitalDesc: '创建您的专属数字角色',
      },
      recentTitle: '最近活动',
      recentVideos: '最近视频生成',
      viewAll: '查看全部',
      empty: '暂无生成记录，快去创作第一个视频吧！',
      stats: {
        completed: '已完成',
        failed: '失败',
        total: '总计',
        noData: '暂无数据',
      },
      poweredBy: '由最前沿的生成式 AI 模型驱动',
    },
    history: {
      title: '生成历史',
      subtitle: '查看所有生成的图片、视频和音频',
      loading: '加载历史记录...',
      stats: {
        total: '总记录',
        images: '图片',
        videos: '视频',
        audios: '音频',
      },
      filters: {
        type: '内容类型',
        all: '全部',
        image: '图片',
        video: '视频',
        audio: '音频',
        source: '来源页面',
        sourceVG: '视频生成',
        sourceDH: '数字人工作流',
      },
      empty: {
        title: '暂无生成记录',
        hint: '开始创建你的第一个作品吧！',
      },
      meta: {
        size: '尺寸',
        duration: '时长',
        seconds: '{sec}秒',
        noPrompt: '无提示词',
        copyTitle: '复制URL',
      },
      types: {
        unknown: '未知',
        image: '图片',
        video: '视频',
        audio: '音频',
        subtypes: {
          text_to_image: '文生图',
          image_to_image: '图生图',
          image_upscale: '图像高清',
          text_to_video: '文生视频',
          image_to_video: '图生视频',
          digital_human_video: '数字人视频',
          video_upscale: '视频高清',
          video_enhance: '视频增强',
          text_to_speech: '文生音频',
          voice_clone: '声音克隆',
          audio_enhance: '音频增强',
        },
      },
    },
    payment: {
      title: '支付管理',
      subtitle: '管理您的账户余额和交易',
      alerts: {
        enterValidAmount: '请输入有效金额',
        createSessionFail: '创建支付会话失败',
        depositFail: '充值失败: {msg}',
        insufficient: '余额不足',
        withdrawSubmitted: '提现请求已提交！金额：${amount}\n请等待管理员审核',
        withdrawFail: '提现失败: {msg}',
      },
      tabs: {
        deposit: '充值',
        withdraw: '提现',
      },
      form: {
        amount: '金额',
        paymentMethod: '支付方式',
        card: '信用卡/借记卡',
        bank: '银行转账',
        processing: '处理中...',
        depositBtn: '充值 ${amount}',
        withdrawBtn: '提现 ${amount}',
        available: '可用余额: ${amount}',
      },
    },
    referral: {
      title: '推荐与计划',
      subtitle: '分享您的推荐码，获得10%返现奖励',
      alerts: {
        copied: '{label} 已复制到剪贴板！',
      },
      codeCard: {
        yourCode: '您的推荐码',
        description: '分享您的推荐码，推荐用户的所有购买您都可获得 10% 返现！',
      },
      stats: {
        users: '推荐用户',
        earnings: '推荐收益',
        cashback: '来自推荐的返现',
      },
      share: {
        title: '分享你的推荐',
        code: '推荐码',
        link: '推荐链接',
      },
      how: {
        title: '如何运作',
        step1Title: '分享你的推荐码',
        step1Desc: '将推荐码或链接发给好友',
        step2Title: '好友注册',
        step2Desc: '新用户使用你的推荐码注册',
        step3Title: '赚取返现',
        step3Desc: '他们的消费你将自动获得 10% 返现',
      },
    },
    superIP: {
      title: '超级 IP',
      subtitle: '创建您的专属数字角色',
      nav: {
        chooseCharacter: '选择角色',
        uploadCharacter: '上传角色',
        chooseVoice: '选择音色',
        uploadVoice: '上传音色',
        generateVideoTab: '生成视频',
        videoStatus: '视频生成',
        send: '发送',
        quickSendTitle: '使用当前上传的图片和音频快速生成视频',
      },
      work: {
        chooseImage: '选择图片',
        openGallery: '打开图库',
        inputPrompt: '输入提示词',
        promptPlaceholder: '输入提示词描述你想要的角色...',
        clear: '清除',
        generateImage: '生成图片',
        generatingImage: '生成中...',
        loadingShort: '生成中...',
        result: '生成结果',
        resultPlaceholderImage: '生成的图片将在这里显示',
        history: '历史记录',
        historyEmpty: '暂无历史记录',
        waveform: '声音波形',
        analyze: '分析中...',
        generate: '匹配',
        selectVoice: '选择音色',
        clearVoice: '清除音色',
        inputText: '输入文本',
        inputTextPlaceholder: '输入要转换为语音的文本...',
        generateVoice: '生成',
        generatingVoice: '生成中...',
        resultPlaceholderAudio: '生成的音频将在这里显示',
        playAudio: '播放音频',
        generateTabPrompt: '输入视频生成提示词，描述你想要的视频内容...',
        generatingVideo: '正在生成视频...',
        playVideo: '播放视频',
        download: '下载',
        resultPlaceholderVideo: '生成的视频将在这里显示',
      },
      sections: {
        voiceClone: '声音克隆'
      },
      clone: {
        selectFile: '选择文件',
        settingsTitle: '设置 Voice ID',
        customVoiceId: '自定义 Voice ID',
        autoNamePlaceholder: '留空则自动生成',
        supportFormats: '支持'
      },
      dialogs: {
        galleryTitle: '选择图片 - 历史记录',
        loading: '加载中...',
        saving: '保存中...',
        empty: '暂无历史图片记录',
        delete: '删除',
        confirmDelete: '确定要删除这张图片吗？',
        selectVoiceTitle: '选择音色',
        systemVoices: '系统音色',
        generatedVoices: '生成音色',
        customVoices: '自定义音色',
  cloneVoices: '克隆音色',
  cloneVoices: '克隆音色',
        unnamedVoice: '未命名音色',
        analyzeTitle: '生成试听',
        analyzePrompt: '提示词（用于分析）',
        trialText: '试听文本',
        resetTrialText: '重置试听文本',
        refreshAnalyze: '刷新分析',
        generateTrialProcessing: '试听生成中...',
        generateTrial: '生成试听音频',
      },
      placeholders: {
        result: 'RESULT',
      },
      alerts: {
        imageGenFailNoUrl: '生成失败，未获取到图片URL',
        imageGenFail: '图片生成失败: {msg}',
        deleteFailed: '删除失败',
        needCharacterImage: '请先上传或选择一个角色图片',
        analyzeInvalid: '分析结果格式异常',
        analyzeFail: '分析失败，请检查网络或后端',
        needAnalyzeOrPrompt: '请先分析角色图片或输入音色提示词',
        needTrialText: '请填写试听文本',
        trialFail: '试听生成失败',
        playFail: '播放失败',
        needVoiceId: '请先选择音色或生成试听以获取可用的 voice_id',
        audioUploadFail: '音频上传失败: {msg}',
        imageUploadFail: '图片上传失败: {msg}',
        videoGenNoUrl: '视频生成失败或未返回视频URL',
        genFail: '生成失败',
      },
    },
    subscriptionPage: {
      title: '订阅计划',
      compareButton: '查看完整权益对比',
      statusLabel: '当前状态：',
      freeSuffix: '免费版',
      planSuffix: '计划',
      currentPlanCardLabel: '当前套餐',
      monthlyCreditsLabel: '月度积分',
      yearlyCreditsLabel: '年度积分',
      yearlyGrantInfo: '年付一次性发放全年积分',
      successGeneric: '订阅已更新，积分已到账。',
      successMonthly: '订阅已生效，当期发放 {credits} 积分。',
      successYearly: '订阅已生效，已一次性发放 {credits} 积分（年付）。',
      placeholderLabel: '占位',
      manageButton: '管理订阅',
      usedLabel: '已使用',
      remainingLabelPrefix: '本月剩余积分:',
      buyExtraCredits: '购买额外积分包 →',
      upgradePrefix: '升级到',
      creatorName: '创作者',
      businessName: '商业版',
      enterpriseName: '企业版',
      upgradeBenefitsIntro: '获得更多功能与更高月度积分。',
      benefitMonthlyCreditsSuffix: '积分/月',
      benefitTeamCollaboration: '团队协作功能',
      benefitEnterpriseCustom: '自定义配额与专属支持',
      upgradeButton: '去升级',
      highestTitle: '已是最高等级',
      highestDescription: '您的套餐为企业版，所有功能均已解锁。',
      highestContact: '如需定制合作请联系销售。',
      expiryPrefix: '到期时间：',
      expiryFree: '无限',
      expiryCustom: '自定义',
      expiryUnknown: '未知',
      errors: {
        notLoggedIn: '未登录，无法获取订阅信息',
        fetchFailed: '获取用户信息失败',
      },
    },
    videoGeneration: {
      headerTitle: '生成视频记录',
      headerSubtitle: '暂无生成记录，立即创作你的第一个视频吧！',
      tabs: {
        t2v: '文生视频',
        i2v: '图生视频',
        enhance: '视频增强',
        backupI2v: '图生视频（备用）',
        newI2v: '图生视频（新）',
      },
      compare: {
        original: '原始视频',
        enhanced: '增强后视频',
      },
      form: {
        promptLabel: '输入提示词',
        promptT2VPlaceholder: '描述你想要生成的视频...',
        promptI2VPlaceholder: '描述视频动作和效果...',
        modelLabel: '模型选择',
        ratioLabel: '视频比例',
        durationLabel: '时长',
        resolutionLabel: '目标分辨率',
        seconds: '{sec}秒',
        hdMode: '高清模式',
        uploadImageLabel: '上传图片',
        uploadImageDrop: '拖拽图片到此处或点击选择',
        uploadImageHint: '支持 JPG、PNG、WEBP，最大 20MB',
        sizeLabel: '清晰度 (SIZE)',
        sizeSmall: '标清 (small)',
        sizeLarge: '高清 (large)',
        uploadVideoLabel: '上传视频',
        uploadVideoDrop: '拖拽视频到此处或点击选择',
        uploadVideoHint: '支持 MP4、WEBM、MOV，最长 15 秒',
        modeLabel: '处理模式',
        modeTiny: '快速模式 (tiny)',
        modeFull: '高质量模式 (full)',
        scaleLabel: '放大倍数',
        clear: '清除',
        submit: '生成',
        submitting: '提交中...',
        generating: '生成中...',
        enhancing: '处理中...',
        enhanceSubmit: '增强',
      },
      empty: {
        resultTitle: 'RESULT',
        resultHint: '生成后结果会显示在这里',
      },
      alerts: {
        uploadImageFail: '上传失败',
        needImageFile: '请上传图片文件（JPG、PNG 或 WEBP）',
        uploadVideoFail: '视频上传失败',
        needVideoFile: '请上传视频文件（MP4、WEBM 或 MOV）',
        needVideoFirst: '请先上传视频',
  videoDurationUnknown: '无法读取视频时长，请上传时长不超过15秒的 MP4/WEBM/MOV 文件',
        videoDurationExceeded: '视频时长不能超过15秒',
        enhanceFail: '视频增强失败：{msg}',
        generateFailRetry: '生成失败，请重试',
        needPrompt: '请填写提示词 (prompt)',
        imageUploadRetry: '图片上传失败，请重试',
        needImageOrUrl: '请先上传图片或填写图片 URL',
        unexpectedResponse: '生成接口返回非预期结构，已在结果区显示原始响应并打印到控制台',
        generateFailWithMsg: '生成失败，后端返回：{msg}',
        generateFail: '生成失败',
        notFoundStopped: '后端未找到任务或已停止处理（客户端错误），已停止轮询。',
        pollingFail: '轮询失败：连续多次请求错误，已停止。',
        i2vPollingFail: '图生视频轮询失败：连续多次请求错误，已停止。',
      },
    },
  },
  en: {
    common: {
      clear: 'Clear',
      analyzing: 'Analyzing...',
      copy: 'Copy',
      copied: 'Copied',
    },
    login: {
      title: 'VGOT',
      welcomeBack: 'Welcome Back',
      createAccount: 'Create Account',
      username: 'Username',
      password: 'Password',
      email: 'Email',
      verificationCode: 'Verification Code',
      inviteCode: 'Invite Code (Optional)',
      usernamePlaceholder: 'Enter username',
      passwordPlaceholder: 'Enter password',
      emailPlaceholder: 'Enter email',
      verificationCodePlaceholder: 'Enter verification code',
      inviteCodePlaceholder: 'Enter invite code (optional)',
      sendCode: 'Send Code',
      sending: 'Sending...',
      resendIn: 'Resend in {sec}s',
      loginButton: 'Login',
      registerButton: 'Register',
      loggingIn: 'Logging in...',
      registering: 'Registering...',
      orDivider: 'or',
      googleLogin: 'Sign in with Google',
      hasAccount: 'Already have an account?',
      noAccount: "Don't have an account?",
      goToLogin: 'Sign in',
      goToRegister: 'Sign up',
      codeSent: 'Verification code has been sent to your email',
      registerSuccess: 'Registration successful! Please login',
    },
    landing: {
      loginBtn: 'Login',
      title: 'VGOT - Achieve Excellent Content Creation',
      subtitle: 'Explore e-commerce viral video creation with VGOT. Support watermark-free HD SORA2 video generation, video quality enhancement, viral script analysis, digital human creation, and more...',
      loading: 'Loading…',
    },
    sidebar: {
      workspace: 'Workspace',
      history: 'History',
      section: {
        replicator: 'Trending Replicator',
        commerce: 'Commerce Videos',
        finance: 'Finance & Growth',
        account: 'Account',
      },
      scripts: 'Scripts',
      digitalExpert: 'Digital Expert',
  sora: 'HyperSell',
      superIP: 'Super IP',
      partner: 'Partner Program',
      subscription: 'Subscription',
      credits: 'Credits & Usage',
      payment: 'Payment',
      referral: 'Referral & Plans',
      logout: 'Logout',
      userMenu: {
        toggleLang: 'Switch Language',
      },
    },
    videoAnalysis: {
      title: 'Get video insights in seconds',
      subtitle: 'Choose a goal, paste a link, and get actionable insights fast',
      uploadTitle: 'Drag & drop or click to upload',
      uploadImageTitle: 'Drag & drop or click to upload image',
      uploadHint: 'Supports MP4, MOV, etc. Recommended 720p+',
      chooseVideo: 'Choose Video',
      clearFile: 'Clear',
      securityHint: 'Your video is uploaded securely and used only for analysis',
  urlLabel: 'Or paste a video link (TikTok supported)',
  urlLabelBasic: 'Or paste a video link',
      placeholder: 'https://www.tiktok.com/@nickname/video/7548476830056025374',
      optionsTitle: 'Analysis Options',
  optionScriptTitle: 'Extract Audio Copy',
  optionScriptDesc: 'Extract the audio transcript from the video',
  optionSceneTitle: 'Reverse Prompt',
  optionSceneDesc: 'Analyze the video and infer prompts in one click',
  optionRewriteTitle: 'Viral Copy',
  optionRewriteDesc: 'Generate viral copy from product info and images in one click',
      startAnalyze: 'Analyze',
      loadingText: 'Analyzing, please wait...',
      resultTitle: 'Results',
      resultPlaceholder: 'Results will appear here',
      rewritePlaceholder: 'Enter the script content you want to rewrite...',
      alerts: {
        needUrl: 'Please enter a video URL',
        extractFail: 'Extraction failed, please try again',
        needInput: 'Please upload a video or enter a URL',
        needRewriteText: 'Please enter script content to rewrite',
        rewriteFail: 'Script rewrite failed, please try again',
      },
    },
    videoGeneration: {
      headerTitle: 'Generated Videos',
      headerSubtitle: "No videos yet — create your first one now!",
      tabs: {
        t2v: 'Text to Video',
        i2v: 'Image to Video',
        enhance: 'Video Enhance',
        backupI2v: 'Image to Video (Backup)',
        newI2v: 'Image to Video (New)',
      },
      compare: {
        original: 'Original',
        enhanced: 'Enhanced',
      },
      form: {
        promptLabel: 'Prompt',
        promptT2VPlaceholder: 'Describe the video you want to create...',
        promptI2VPlaceholder: 'Describe actions and effects...',
        modelLabel: 'Model',
        ratioLabel: 'Aspect Ratio',
        durationLabel: 'Duration',
  resolutionLabel: 'Target Resolution',
        seconds: '{sec}s',
        hdMode: 'HD Mode',
        uploadImageLabel: 'Upload Image',
        uploadImageDrop: 'Drag an image here or click to select',
        uploadImageHint: 'JPG, PNG, WEBP up to 20MB',
        sizeLabel: 'Resolution (SIZE)',
        sizeSmall: 'SD (small)',
        sizeLarge: 'HD (large)',
        uploadVideoLabel: 'Upload Video',
        uploadVideoDrop: 'Drag a video here or click to select',
        uploadVideoHint: 'MP4, WEBM, MOV up to 15s',
        modeLabel: 'Mode',
        modeTiny: 'Fast (tiny)',
        modeFull: 'High Quality (full)',
        scaleLabel: 'Upscale',
        clear: 'Clear',
        submit: 'Generate Video',
        submitting: 'Submitting...',
        generating: 'Generating...',
        enhancing: 'Processing...',
        enhanceSubmit: 'Enhance Video',
      },
      empty: {
        resultTitle: 'RESULT',
        resultHint: 'Your result will appear here',
      },
      alerts: {
        uploadImageFail: 'Upload failed',
        needImageFile: 'Please upload an image file (JPG, PNG, or WEBP)',
        uploadVideoFail: 'Video upload failed',
        needVideoFile: 'Please upload a video file (MP4, WEBM, or MOV)',
        needVideoFirst: 'Please upload a video first',
  videoDurationUnknown: 'Unable to read video duration. Please upload MP4/WEBM/MOV up to 15s.',
        videoDurationExceeded: 'Video duration must be 15 seconds or less',
        enhanceFail: 'Video enhance failed: {msg}',
        generateFailRetry: 'Generation failed, please try again',
        needPrompt: 'Please enter a prompt',
        imageUploadRetry: 'Image upload failed, please try again',
        needImageOrUrl: 'Please upload an image or provide an image URL',
        unexpectedResponse: 'Unexpected response. Raw data printed in console and shown on the right.',
        generateFailWithMsg: 'Generation failed: {msg}',
        generateFail: 'Generation failed',
        notFoundStopped: 'Task not found or server stopped. Polling aborted.',
        pollingFail: 'Polling failed: too many consecutive errors. Stopped.',
        i2vPollingFail: 'Image-to-video polling failed: too many errors. Stopped.',
      },
    },
    workspace: {
      title: 'What would you like to create today?',
      cards: {
        generateTitle: 'Generate Video',
  generateDesc: 'Generate videos and create stunning work',
        analyzeTitle: 'Analyze Video',
        analyzeDesc: 'Get script ideas fast and chat for more creativity',
        digitalTitle: 'Super IP',
        digitalDesc: 'Create your own digital character',
      },
      recentTitle: 'Recent Activity',
      recentVideos: 'Recent Generations',
      viewAll: 'View All',
      empty: 'No generations yet — create your first video!',
      stats: {
        completed: 'Completed',
        failed: 'Failed',
        total: 'Total',
        noData: 'No data',
      },
      poweredBy: 'Powered by cutting-edge generative AI models',
    },
    history: {
      title: 'Generation History',
      subtitle: 'Browse all generated images, videos, and audio',
      loading: 'Loading history...',
      stats: {
        total: 'Total',
        images: 'Images',
        videos: 'Videos',
        audios: 'Audio',
      },
      filters: {
        type: 'Content Type',
        all: 'All',
        image: 'Image',
        video: 'Video',
        audio: 'Audio',
        source: 'Source Page',
        sourceVG: 'Video Generation',
        sourceDH: 'Digital Human Flow',
      },
      empty: {
        title: 'No records yet',
        hint: 'Start creating your first work!',
      },
      meta: {
        size: 'Size',
        duration: 'Duration',
        seconds: '{sec}s',
        noPrompt: 'No prompt',
        copyTitle: 'Copy URL',
      },
      types: {
        unknown: 'Unknown',
        image: 'Image',
        video: 'Video',
        audio: 'Audio',
        subtypes: {
          text_to_image: 'Text-to-Image',
          image_to_image: 'Image-to-Image',
          image_upscale: 'Image Upscale',
          text_to_video: 'Text-to-Video',
          image_to_video: 'Image-to-Video',
          digital_human_video: 'Digital Human Video',
          video_upscale: 'Video Upscale',
          video_enhance: 'Video Enhance',
          text_to_speech: 'Text-to-Speech',
          voice_clone: 'Voice Clone',
          audio_enhance: 'Audio Enhance',
        },
      },
    },
    payment: {
      title: 'Payment Management',
      subtitle: 'Manage your account balance and transactions',
      alerts: {
        enterValidAmount: 'Please enter a valid amount',
        createSessionFail: 'Failed to create checkout session',
        depositFail: 'Deposit failed: {msg}',
        insufficient: 'Insufficient balance',
        withdrawSubmitted: 'Withdrawal request submitted! Amount: ${amount}\nPlease wait for admin review',
        withdrawFail: 'Withdrawal failed: {msg}',
      },
      tabs: {
        deposit: 'Deposit',
        withdraw: 'Withdraw',
      },
      form: {
        amount: 'Amount',
        paymentMethod: 'Payment Method',
        card: 'Credit / Debit Card',
        bank: 'Bank Transfer',
        processing: 'Processing...',
        depositBtn: 'Deposit ${amount}',
        withdrawBtn: 'Withdraw ${amount}',
        available: 'Available: ${amount}',
      },
    },
    referral: {
      title: 'Referral & Plans',
      subtitle: 'Share your referral code and earn 10% cashback',
      alerts: {
        copied: '{label} copied to clipboard!',
      },
      codeCard: {
        yourCode: 'Your Referral Code',
        description: 'Share your referral code and earn 10% cashback on all purchases made by referred users!',
      },
      stats: {
        users: 'Referred Users',
        earnings: 'Referral Earnings',
        cashback: 'Cashback from referrals',
      },
      share: {
        title: 'Share Your Referral',
        code: 'Your Referral Code',
        link: 'Referral Link',
      },
      how: {
        title: 'How It Works',
        step1Title: 'Share Your Code',
        step1Desc: 'Send your referral code or link to friends',
        step2Title: 'They Sign Up',
        step2Desc: 'New users register using your referral code',
        step3Title: 'Earn Cashback',
        step3Desc: 'Get 10% cashback on their purchases automatically',
      },
    },
    superIP: {
      title: 'Super IP',
      subtitle: 'Create your own digital character',
      nav: {
        chooseCharacter: 'Choose Character',
        uploadCharacter: 'Upload Character',
        chooseVoice: 'Choose Voice',
        uploadVoice: 'Upload Voice',
        generateVideoTab: 'Generate',
        videoStatus: 'Video Status',
        send: 'Send',
        quickSendTitle: 'Quickly generate video with current image and audio',
      },
      work: {
        chooseImage: 'Choose Image',
        openGallery: 'Open Gallery',
        inputPrompt: 'Enter Prompt',
        promptPlaceholder: 'Describe the character you want...',
        clear: 'Clear',
        generateImage: 'Generate',
        generatingImage: 'Generating...',
        loadingShort: 'Generating...',
        result: 'Result',
        resultPlaceholderImage: 'Generated image will appear here',
        history: 'History',
        historyEmpty: 'No history yet',
        waveform: 'Waveform',
        analyze: 'Analyzing...',
        generate: 'Match',
        selectVoice: 'Select Voice',
        clearVoice: 'Clear Voice',
        inputText: 'Input Text',
        inputTextPlaceholder: 'Enter text to convert to speech...',
        generateVoice: 'Generate',
        generatingVoice: 'Generating...',
        resultPlaceholderAudio: 'Generated audio will appear here',
        playAudio: 'Play Audio',
        generateTabPrompt: 'Enter a prompt describing the video you want...',
        generatingVideo: 'Generating video...',
        playVideo: 'Play',
        download: 'Download',
        resultPlaceholderVideo: 'Generated video will appear here',
      },
      sections: {
        voiceClone: 'Voice Clone',
      },
      clone: {
        selectFile: 'Select File',
        settingsTitle: 'Set Voice ID',
        customVoiceId: 'Custom Voice ID',
        autoNamePlaceholder: 'Leave empty to auto-generate',
        supportFormats: 'Supports',
      },
      dialogs: {
        galleryTitle: 'Select Image - History',
        loading: 'Loading...',
        saving: 'Saving...',
        empty: 'No image history',
        delete: 'Delete',
        confirmDelete: 'Are you sure you want to delete this image?',
        selectVoiceTitle: 'Select Voice',
        systemVoices: 'System Voices',
        generatedVoices: 'Generated Voices',
        customVoices: 'Custom Voices',
  cloneVoices: 'Cloned Voices',
        unnamedVoice: 'Unnamed Voice',
        analyzeTitle: 'Generate Trial',
        analyzePrompt: 'Prompt (for analysis)',
        trialText: 'Trial Text',
        resetTrialText: 'Reset trial text',
        refreshAnalyze: 'Refresh Analysis',
        generateTrialProcessing: 'Generating trial...',
        generateTrial: 'Generate Trial Audio',
      },
      placeholders: {
        result: 'RESULT',
      },
      alerts: {
        imageGenFailNoUrl: 'Generation failed, no image URL returned',
        imageGenFail: 'Image generation failed: {msg}',
        deleteFailed: 'Delete failed',
        needCharacterImage: 'Please upload or select a character image first',
        analyzeInvalid: 'Invalid analysis result',
        analyzeFail: 'Analysis failed, please check your network or server',
        needAnalyzeOrPrompt: 'Please analyze character image or provide a voice prompt first',
        needTrialText: 'Please enter trial text',
        trialFail: 'Trial generation failed',
        playFail: 'Playback failed',
        needVoiceId: 'Please select a voice or generate a trial to obtain a usable voice_id',
        audioUploadFail: 'Audio upload failed: {msg}',
        imageUploadFail: 'Image upload failed: {msg}',
        videoGenNoUrl: 'Video generation failed or no video URL returned',
        genFail: 'Generation failed',
      },
    },
    subscriptionPage: {
      title: 'Subscription Plans',
      compareButton: 'View Full Benefits Comparison',
      statusLabel: 'Current Status:',
      freeSuffix: 'Free',
      planSuffix: 'Plan',
      currentPlanCardLabel: 'Current Plan',
      monthlyCreditsLabel: 'Monthly Credits',
      yearlyCreditsLabel: 'Yearly Credits',
      yearlyGrantInfo: 'Yearly plans grant the full year\'s credits upfront',
      successGeneric: 'Subscription updated. Credits have been added to your balance.',
      successMonthly: 'Subscription activated. {credits} credits granted for this cycle.',
      successYearly: 'Subscription activated. {credits} credits have been added (yearly upfront).',
      placeholderLabel: 'Placeholder',
      manageButton: 'Manage Subscription',
      usedLabel: 'Used',
      remainingLabelPrefix: 'Remaining this month:',
      buyExtraCredits: 'Buy extra credit pack →',
      upgradePrefix: 'Upgrade to',
      creatorName: 'Creator',
      businessName: 'Business',
      enterpriseName: 'Enterprise',
      upgradeBenefitsIntro: 'Get more features and higher monthly credits.',
      benefitMonthlyCreditsSuffix: 'credits/month',
      benefitTeamCollaboration: 'Team collaboration features',
      benefitEnterpriseCustom: 'Custom quota & dedicated support',
      upgradeButton: 'Upgrade',
      highestTitle: 'Already at highest tier',
      highestDescription: 'You are on Enterprise, all features unlocked.',
      highestContact: 'Contact sales for custom solutions.',
      expiryPrefix: 'Expiry:',
      expiryFree: 'Unlimited',
      expiryCustom: 'Custom',
      expiryUnknown: 'Unknown',
      errors: {
        notLoggedIn: 'Not logged in, unable to fetch subscription info',
        fetchFailed: 'Failed to fetch user info',
      },
    },
  },
  'zh-TW': {
    common: {
      clear: '清除',
      analyzing: '分析中...',
      copy: '複製',
      copied: '已複製',
    },
    login: {
      title: 'VGOT',
      welcomeBack: '歡迎回來',
      createAccount: '創建賬號',
      username: '用戶名',
      password: '密碼',
      email: '郵箱',
      verificationCode: '驗證碼',
      inviteCode: '邀請碼 (可選)',
      usernamePlaceholder: '請輸入用戶名',
      passwordPlaceholder: '請輸入密碼',
      emailPlaceholder: '請輸入郵箱',
      verificationCodePlaceholder: '請輸入驗證碼',
      inviteCodePlaceholder: '請輸入邀請碼（可不填）',
      sendCode: '發送驗證碼',
      sending: '發送中...',
      resendIn: '{sec}s後重發',
      loginButton: '登錄',
      registerButton: '註冊',
      loggingIn: '登錄中...',
      registering: '註冊中...',
      orDivider: '或',
      googleLogin: '使用 Google 登錄',
      hasAccount: '已有賬號？',
      noAccount: '還沒有賬號？',
      goToLogin: '去登錄',
      goToRegister: '立即註冊',
      codeSent: '驗證碼已發送至您的郵箱',
      registerSuccess: '註冊成功！請登錄',
    },
    landing: {
      loginBtn: '登錄',
      title: 'VGOT實現優秀的內容創作',
      subtitle: '使用VGOT一起探索電商爆款視頻製作，支持無水印高清SORA2視頻製作，增強視頻畫質，爆款腳本分析，數字人製作等等...',
      loading: '加載中…',
    },
    sidebar: {
      workspace: '工作台',
      history: '生成記錄',
      section: {
        replicator: '爆款復刻',
        commerce: '帶貨視頻',
        finance: '財務與增長',
        account: '賬號',
      },
      scripts: '腳本',
      digitalExpert: '數字專家',
  sora: 'HyperSell',
  superIP: 'Super IP',
      partner: '推廣計劃',
      subscription: '訂閱計劃',
      payment: '支付',
      referral: '推薦與計劃',
      credits: '積分與算力',
      noEmail: '未綁定郵箱',
      logout: '退出',
      userMenu: {
        toggleLang: '切換語言',
        upgrade: '升級套餐',
        credits: '積分',
        freeplan: 'Free 套餐',
      },
    },
    videoAnalysis: {
      title: '數秒內獲取視頻洞察',
      subtitle: '選擇分析目標，粘貼視頻鏈接，快速獲得可執行的洞察',
      uploadTitle: '拖拽或點擊上傳',
      uploadImageTitle: '拖拽或點擊上傳圖片',
      uploadHint: '支持 MP4、MOV 等格式，推薦尺寸 720P+',
      chooseVideo: '選擇視頻',
      clearFile: '清除',
      securityHint: '視頻將安全上傳至服務器，僅用於提取提示詞',
  urlLabel: '或粘貼視頻鏈接（支持 TikTok 鏈接）',
  urlLabelBasic: '或粘貼視頻鏈接',
      placeholder: 'https://www.tiktok.com/@nickname/video/7548476830056025374',
      optionsTitle: '分析選項',
  optionScriptTitle: '提取音頻文案',
  optionScriptDesc: '從視頻中提取音頻腳本文案',
  optionSceneTitle: '反推提示詞',
  optionSceneDesc: '分析視頻內容，一鍵反推提示詞',
  optionRewriteTitle: '爆款文案',
  optionRewriteDesc: '根據產品資訊與產品圖片一鍵生成爆款文案',
      startAnalyze: '開始分析',
      loadingText: '分析中，請稍候...',
      resultTitle: '分析結果',
      resultPlaceholder: '分析結果將顯示在這裡',
      rewritePlaceholder: '請輸入需要改寫的腳本內容...',
      alerts: {
        needUrl: '請輸入視頻URL',
        extractFail: '提取失敗，請重試',
        needInput: '請上傳視頻或輸入視頻URL',
        needRewriteText: '請輸入需要改寫的腳本內容',
        rewriteFail: '腳本改寫失敗，請重試',
      },
      
    },
    videoGeneration: {
      headerTitle: '生成視頻記錄',
      headerSubtitle: '暫無生成記錄，立即創作你的第一個視頻吧！',
      tabs: {
        t2v: '文生視頻',
        i2v: '圖生視頻',
        enhance: '視頻增強',
        backupI2v: '圖生視頻（備用）',
      },
      compare: {
        original: '原始視頻',
        enhanced: '增強後視頻',
      },
      form: {
        promptLabel: '輸入提示詞',
        promptT2VPlaceholder: '描述你想要生成的視頻...',
        promptI2VPlaceholder: '描述視頻動作和效果...',
        modelLabel: '模型選擇',
        ratioLabel: '視頻比例',
        durationLabel: '時長',
  resolutionLabel: '目標分辨率',
        seconds: '{sec}秒',
        hdMode: '高清模式',
        uploadImageLabel: '上傳圖片 (IMAGE)',
        uploadImageDrop: '拖拽圖片到此處或點擊選擇',
        uploadImageHint: '支持 JPG、PNG、WEBP，最大 20MB',
        sizeLabel: '清晰度 (SIZE)',
        sizeSmall: '標清 (small)',
        sizeLarge: '高清 (large)',
        uploadVideoLabel: '上傳視頻 (VIDEO)',
        uploadVideoDrop: '拖拽視頻到此處或點擊選擇',
        uploadVideoHint: '支持 MP4、WEBM、MOV，最長 15 秒',
        modeLabel: '處理模式',
        modeTiny: '快速模式 (tiny)',
        modeFull: '高質量模式 (full)',
        scaleLabel: '放大倍數',
        clear: '清除',
  submit: '生成',
        submitting: '提交中...',
        generating: '生成中...',
        enhancing: '處理中...',
  enhanceSubmit: '增強',
      },
      empty: {
        resultTitle: 'RESULT',
        resultHint: '生成後結果會顯示在這裡',
      },
      alerts: {
        uploadImageFail: '上傳失敗',
        needImageFile: '請上傳圖片文件（JPG、PNG 或 WEBP）',
        uploadVideoFail: '視頻上傳失敗',
        needVideoFile: '請上傳視頻文件（MP4、WEBM 或 MOV）',
  needVideoFirst: '請先上傳視頻',
  videoDurationUnknown: '無法讀取視頻時長，請上傳時長不超過15秒的 MP4/WEBM/MOV 文件',
        videoDurationExceeded: '視頻時長不能超過15秒',
        enhanceFail: '視頻增強失敗：{msg}',
        generateFailRetry: '生成失敗，請重試',
        needPrompt: '請填寫提示詞 (prompt)',
        imageUploadRetry: '圖片上傳失敗，請重試',
        needImageOrUrl: '請先上傳圖片或填寫圖片 URL',
        unexpectedResponse: '生成接口返回非預期結構，已在結果區顯示原始響應並打印到控制台',
        generateFailWithMsg: '生成失敗，後端返回：{msg}',
        generateFail: '生成失敗',
        notFoundStopped: '後端未找到任務或已停止處理（客戶端錯誤），已停止輪詢。',
        pollingFail: '輪詢失敗：連續多次請求錯誤，已停止。',
        i2vPollingFail: '圖生視頻輪詢失敗：連續多次請求錯誤，已停止。',
      },
    },
    workspace: {
      title: '你好！今天想創作什麼？',
      cards: {
        generateTitle: '生成視頻',
  generateDesc: '生成視頻，創造令人驚艷的作品',
        analyzeTitle: '分析視頻',
        analyzeDesc: '快速獲取視頻的腳本靈感，聊天探索更多創意',
        digitalTitle: 'Super IP',
        digitalDesc: '創建您的專屬數字角色',
      },
      recentTitle: '最近活動',
      recentVideos: '最近視頻生成',
      viewAll: '查看全部',
      empty: '暫無生成記錄，快去創作第一個視頻吧！',
      stats: {
        completed: '已完成',
        failed: '失敗',
        total: '總計',
        noData: '暫無數據',
      },
      poweredBy: '由最前沿的生成式 AI 模型驅動',
    },
    history: {
      title: '生成歷史',
      subtitle: '查看所有生成的圖片、視頻和音頻',
      loading: '加載歷史記錄...',
      stats: {
        total: '總記錄',
        images: '圖片',
        videos: '視頻',
        audios: '音頻',
      },
      filters: {
        type: '內容類型',
        all: '全部',
        image: '圖片',
        video: '視頻',
        audio: '音頻',
        source: '來源頁面',
        sourceVG: '視頻生成',
        sourceDH: '數字人工作流',
      },
      empty: {
        title: '暫無生成記錄',
        hint: '開始創建你的第一個作品吧！',
      },
      meta: {
        size: '尺寸',
        duration: '時長',
        seconds: '{sec}秒',
        noPrompt: '無提示詞',
        copyTitle: '複製URL',
      },
      types: {
        unknown: '未知',
        image: '圖片',
        video: '視頻',
        audio: '音頻',
        subtypes: {
          text_to_image: '文生圖',
          image_to_image: '圖生圖',
          image_upscale: '圖像高清',
          text_to_video: '文生視頻',
          image_to_video: '圖生視頻',
          digital_human_video: '數字人視頻',
          video_upscale: '視頻高清',
          video_enhance: '視頻增強',
          text_to_speech: '文生音頻',
          voice_clone: '聲音克隆',
          audio_enhance: '音頻增強',
        },
      },
    },
    payment: {
      title: '支付管理',
      subtitle: '管理您的賬戶餘額和交易',
      alerts: {
        enterValidAmount: '請輸入有效金額',
        createSessionFail: '創建支付會話失敗',
        depositFail: '充值失敗: {msg}',
        insufficient: '餘額不足',
        withdrawSubmitted: '提現請求已提交！金額：${amount}\n請等待管理員審核',
        withdrawFail: '提現失敗: {msg}',
      },
      tabs: {
        deposit: '充值',
        withdraw: '提現',
      },
      form: {
        amount: '金額',
        paymentMethod: '支付方式',
        card: '信用卡/借記卡',
        bank: '銀行轉賬',
        processing: '處理中...',
        depositBtn: '充值 ${amount}',
        withdrawBtn: '提現 ${amount}',
        available: '可用餘額: ${amount}',
      },
    },
    referral: {
      title: '推薦與計劃',
      subtitle: '分享您的推薦碼，獲得10%返現獎勵',
      alerts: {
        copied: '{label} 已複製到剪貼板！',
      },
      codeCard: {
        yourCode: '您的推薦碼',
        description: '分享您的推薦碼，推薦用戶的所有購買您都可獲得 10% 返現！',
      },
      stats: {
        users: '推薦用戶',
        earnings: '推薦收益',
        cashback: '來自推薦的返現',
      },
      share: {
        title: '分享你的推薦',
        code: '推薦碼',
        link: '推薦鏈接',
      },
      how: {
        title: '如何運作',
        step1Title: '分享你的推薦碼',
        step1Desc: '將推薦碼或鏈接發給好友',
        step2Title: '好友註冊',
        step2Desc: '新用戶使用你的推薦碼註冊',
        step3Title: '賺取返現',
        step3Desc: '他們的消費你將自動獲得 10% 返現',
      },
    },
    superIP: {
      title: '超級 IP',
      subtitle: '創建您的專屬數字角色',
      nav: {
        chooseCharacter: '選擇角色',
        uploadCharacter: '上傳角色',
        chooseVoice: '選擇音色',
        uploadVoice: '上傳音色',
        generateVideoTab: '生成視頻',
        videoStatus: '視頻生成',
        send: '發送',
        quickSendTitle: '使用當前上傳的圖片和音頻快速生成視頻',
      },
      work: {
        chooseImage: '選擇圖片',
        openGallery: '打開圖庫',
        inputPrompt: '輸入提示詞',
        promptPlaceholder: '輸入提示詞描述你想要的角色...',
        clear: '清除',
        generateImage: '生成圖片',
        generatingImage: '生成中...',
        result: '生成結果',
        resultPlaceholderImage: '生成的圖片將在這裡顯示',
        history: '歷史記錄',
        historyEmpty: '暫無歷史記錄',
        waveform: '聲音波形',
        analyze: '分析中...',
        generate: '匹配',
        selectVoice: '選擇音色',
        clearVoice: '清除音色',
        inputText: '輸入文本',
        inputTextPlaceholder: '輸入要轉換為語音的文本...',
        generateVoice: '生成',
        generatingVoice: '生成中...',
        resultPlaceholderAudio: '生成的音頻將在這裡顯示',
        playAudio: '播放音頻',
        generateTabPrompt: '輸入視頻生成提示詞，描述你想要的視頻內容...',
        generatingVideo: '正在生成視頻...',
        playVideo: '播放視頻',
        download: '下載',
        resultPlaceholderVideo: '生成的視頻將在這裡顯示',
      },
      sections: {
        voiceClone: '聲音克隆',
      },
      clone: {
        selectFile: '選擇文件',
        settingsTitle: '設置 Voice ID',
        customVoiceId: '自定義 Voice ID',
        autoNamePlaceholder: '留空則自動生成',
        supportFormats: '支持',
      },
      dialogs: {
        galleryTitle: '選擇圖片 - 歷史記錄',
        loading: '加載中...',
        saving: '保存中...',
        empty: '暫無歷史圖片記錄',
        delete: '刪除',
        confirmDelete: '確定要刪除這張圖片嗎？',
        selectVoiceTitle: '選擇音色',
        systemVoices: '系統音色',
        generatedVoices: '生成音色',
        customVoices: '自定義音色',
        unnamedVoice: '未命名音色',
        analyzeTitle: '生成試聽',
        analyzePrompt: '提示詞（用於分析）',
        trialText: '試聽文本',
        resetTrialText: '重置試聽文本',
        refreshAnalyze: '刷新分析',
        generateTrialProcessing: '試聽生成中...',
        generateTrial: '生成試聽音頻',
      },
      placeholders: {
        result: 'RESULT',
      },
      alerts: {
        imageGenFailNoUrl: '生成失敗，未獲取到圖片URL',
        imageGenFail: '圖片生成失敗: {msg}',
        needCharacterImage: '請先上傳或選擇一個角色圖片',
        analyzeInvalid: '分析結果格式異常',
        analyzeFail: '分析失敗，請檢查網絡或後端',
        needAnalyzeOrPrompt: '請先分析角色圖片或輸入音色提示詞',
        needTrialText: '請填寫試聽文本',
        trialFail: '試聽生成失敗',
        playFail: '播放失敗',
        needVoiceId: '請先選擇音色或生成試聽以獲取可用的 voice_id',
        audioUploadFail: '音頻上傳失敗: {msg}',
        imageUploadFail: '圖片上傳失敗: {msg}',
        videoGenNoUrl: '視頻生成失敗或未返回視頻URL',
        genFail: '生成失敗',
      },
    },
    subscriptionPage: {
      title: '訂閱計劃',
      compareButton: '查看完整權益對比',
      statusLabel: '當前狀態：',
      freeSuffix: '免費版',
      planSuffix: '計劃',
      currentPlanCardLabel: '當前套餐',
      monthlyCreditsLabel: '月度積分',
      yearlyGrantInfo: '年付一次性發放全年積分',
      successGeneric: '訂閱已更新，積分已到賬。',
      successMonthly: '訂閱已生效，當期發放 {credits} 積分。',
      successYearly: '訂閱已生效，已一次性發放 {credits} 積分（年付）。',
      placeholderLabel: '佔位',
      manageButton: '管理訂閱',
      usedLabel: '已使用',
      remainingLabelPrefix: '本月剩餘積分:',
      buyExtraCredits: '購買額外積分包 →',
      upgradePrefix: '升級到',
      creatorName: '創作者',
      businessName: '商業版',
      enterpriseName: '企業版',
      upgradeBenefitsIntro: '獲得更多功能與更高月度積分。',
      benefitMonthlyCreditsSuffix: '積分/月',
      benefitTeamCollaboration: '團隊協作功能',
      benefitEnterpriseCustom: '自定義配額與專屬支持',
      upgradeButton: '去升級',
      highestTitle: '已是最高等級',
      highestDescription: '您的套餐為企業版，所有功能均已解鎖。',
      highestContact: '如需定制合作請聯繫銷售。',
      expiryPrefix: '到期時間：',
      expiryFree: '無限',
      expiryCustom: '自定義',
      expiryUnknown: '未知',
      errors: {
        notLoggedIn: '未登錄，無法獲取訂閱信息',
        fetchFailed: '獲取用戶信息失敗',
      },
    },
  },
  es: {
    common: {
      clear: 'Limpiar',
      analyzing: 'Analizando...',
    },
    login: {
      title: 'VGOT',
      welcomeBack: 'Bienvenido de nuevo',
      createAccount: 'Crear cuenta',
      username: 'Nombre de usuario',
      password: 'Contraseña',
      email: 'Correo electrónico',
      verificationCode: 'Código de verificación',
      inviteCode: 'Código de invitación (Opcional)',
      usernamePlaceholder: 'Ingrese nombre de usuario',
      passwordPlaceholder: 'Ingrese contraseña',
      emailPlaceholder: 'Ingrese correo electrónico',
      verificationCodePlaceholder: 'Ingrese código de verificación',
      inviteCodePlaceholder: 'Ingrese código de invitación (opcional)',
      sendCode: 'Enviar código',
      sending: 'Enviando...',
      resendIn: 'Reenviar en {sec}s',
      loginButton: 'Iniciar sesión',
      registerButton: 'Registrarse',
      loggingIn: 'Iniciando sesión...',
      registering: 'Registrando...',
      orDivider: 'o',
      googleLogin: 'Iniciar sesión con Google',
      hasAccount: '¿Ya tienes una cuenta?',
      noAccount: '¿No tienes una cuenta?',
      goToLogin: 'Iniciar sesión',
      goToRegister: 'Regístrate',
      codeSent: 'El código de verificación ha sido enviado a su correo electrónico',
      registerSuccess: '¡Registro exitoso! Por favor inicia sesión',
    },
    landing: {
      loginBtn: 'Iniciar sesión',
      title: 'VGOT - Logra una creación de contenido excelente',
      subtitle: 'Explora la creación de videos virales de comercio electrónico con VGOT. Admite generación de videos SORA2 HD sin marca de agua, mejora de calidad de video, análisis de guiones virales, creación de humanos digitales y más...',
      loading: 'Cargando…',
    },
    sidebar: {
      workspace: 'Espacio de trabajo',
      history: 'Historial',
      section: {
        replicator: 'Replicador de tendencias',
        commerce: 'Videos de comercio',
        finance: 'Finanzas y crecimiento',
        account: 'Cuenta',
      },
      scripts: 'Guiones',
      digitalExpert: 'Experto digital',
  sora: 'HyperSell',
      superIP: 'Super IP',
      partner: 'Programa de socios',
      subscription: 'Planes de suscripción',
      payment: 'Pago',
      referral: 'Referidos y planes',
      credits: 'Créditos y uso',
      noEmail: 'Sin correo',
      logout: 'Cerrar sesión',
      userMenu: {
        toggleLang: 'Cambiar idioma',
        upgrade: 'Mejorar plan',
        credits: 'Créditos',
        freeplan: 'Plan Free',
      },
    },
    videoAnalysis: {
      title: 'Obtén información del video en segundos',
      subtitle: 'Elige un objetivo, pega un enlace y obtén información procesable rápidamente',
      uploadTitle: 'Arrastra y suelta o haz clic para cargar',
      uploadImageTitle: 'Arrastra y suelta o haz clic para cargar imagen',
      uploadHint: 'Admite MP4, MOV, etc. Recomendado 720p+',
      chooseVideo: 'Elegir video',
      clearFile: 'Limpiar',
      securityHint: 'Tu video se carga de forma segura y se usa solo para análisis',
  urlLabel: 'O pega un enlace de video (compatible con TikTok)',
  urlLabelBasic: 'O pega un enlace de video',
      placeholder: 'https://www.tiktok.com/@nickname/video/7548476830056025374',
      optionsTitle: 'Opciones de análisis',
  optionScriptTitle: 'Extraer copy de audio',
  optionScriptDesc: 'Extrae la transcripción del audio del video',
  optionSceneTitle: 'Prompt inverso',
  optionSceneDesc: 'Analiza el contenido del video y genera el prompt con un clic',
  optionRewriteTitle: 'Copy viral',
  optionRewriteDesc: 'Genera un copy viral con un clic a partir de la información e imágenes del producto',
      startAnalyze: 'Analizar',
      loadingText: 'Analizando, por favor espera...',
      resultTitle: 'Resultados',
      resultPlaceholder: 'Los resultados aparecerán aquí',
      alerts: {
        needUrl: 'Por favor ingresa una URL de video',
        extractFail: 'Extracción fallida, por favor intenta de nuevo',
        needInput: 'Por favor carga un video o ingresa una URL',
      },
    },
    videoGeneration: {
      headerTitle: 'Videos generados',
      headerSubtitle: '¡Aún no hay videos, crea el primero ahora!',
      tabs: {
        t2v: 'Texto a video',
        i2v: 'Imagen a video',
        enhance: 'Mejorar video',
        backupI2v: 'Imagen a video (Respaldo)',
      },
      compare: {
        original: 'Original',
        enhanced: 'Mejorado',
      },
      form: {
        promptLabel: 'Indicación',
        promptT2VPlaceholder: 'Describe el video que quieres crear...',
        promptI2VPlaceholder: 'Describe acciones y efectos...',
        modelLabel: 'Modelo',
        ratioLabel: 'Relación de aspecto',
        durationLabel: 'Duración',
  resolutionLabel: 'Resolución Objetivo',
        seconds: '{sec}s',
        hdMode: 'Modo HD',
        uploadImageLabel: 'Cargar imagen',
        uploadImageDrop: 'Arrastra una imagen aquí o haz clic para seleccionar',
        uploadImageHint: 'JPG, PNG, WEBP hasta 20MB',
        sizeLabel: 'Resolución (SIZE)',
        sizeSmall: 'SD (pequeño)',
        sizeLarge: 'HD (grande)',
        uploadVideoLabel: 'Cargar video',
        uploadVideoDrop: 'Arrastra un video aquí o haz clic para seleccionar',
        uploadVideoHint: 'MP4, WEBM, MOV hasta 15s',
        modeLabel: 'Modo',
        modeTiny: 'Rápido (diminuto)',
        modeFull: 'Alta calidad (completo)',
        scaleLabel: 'Ampliar',
        clear: 'Limpiar',
        submit: 'Generar video',
        submitting: 'Enviando...',
        generating: 'Generando...',
        enhancing: 'Procesando...',
        enhanceSubmit: 'Mejorar video',
      },
      empty: {
        resultTitle: 'RESULTADO',
        resultHint: 'Tu resultado aparecerá aquí',
      },
      alerts: {
        uploadImageFail: 'Carga fallida',
        needImageFile: 'Por favor carga un archivo de imagen (JPG, PNG o WEBP)',
        uploadVideoFail: 'Carga de video fallida',
        needVideoFile: 'Por favor carga un archivo de video (MP4, WEBM o MOV)',
        needVideoFirst: 'Por favor carga un video primero',
  videoDurationUnknown: 'No se puede leer la duración del video. Carga MP4/WEBM/MOV de hasta 15s.',
        videoDurationExceeded: 'La duración del video debe ser de 15 segundos o menos',
        enhanceFail: 'Mejora de video fallida: {msg}',
        generateFailRetry: 'Generación fallida, por favor intenta de nuevo',
        needPrompt: 'Por favor ingresa una indicación',
        imageUploadRetry: 'Carga de imagen fallida, por favor intenta de nuevo',
        needImageOrUrl: 'Por favor carga una imagen o proporciona una URL de imagen',
        unexpectedResponse: 'Respuesta inesperada. Datos sin procesar impresos en consola y mostrados a la derecha.',
        generateFailWithMsg: 'Generación fallida: {msg}',
        generateFail: 'Generación fallida',
        notFoundStopped: 'Tarea no encontrada o servidor detenido. Sondeo abortado.',
        pollingFail: 'Sondeo fallido: demasiados errores consecutivos. Detenido.',
        i2vPollingFail: 'Sondeo de imagen a video fallido: demasiados errores. Detenido.',
      },
    },
    workspace: {
      title: '¿Qué te gustaría crear hoy?',
      cards: {
        generateTitle: 'Generar video',
  generateDesc: 'Genera videos y crea resultados impresionantes',
        analyzeTitle: 'Analizar video',
        analyzeDesc: 'Obtén ideas de guiones rápidamente y chatea para más creatividad',
        digitalTitle: 'Super IP',
        digitalDesc: 'Crea tu propio personaje digital',
      },
      recentTitle: 'Actividad reciente',
      recentVideos: 'Generaciones recientes',
      viewAll: 'Ver todo',
      empty: '¡Aún no hay generaciones, crea tu primer video!',
      stats: {
        completed: 'Completado',
        failed: 'Fallido',
        total: 'Total',
        noData: 'Sin datos',
      },
      poweredBy: 'Impulsado por modelos de IA generativa de vanguardia',
    },
    history: {
      title: 'Historial de generación',
      subtitle: 'Explora todas las imágenes, videos y audio generados',
      loading: 'Cargando historial...',
      stats: {
        total: 'Total',
        images: 'Imágenes',
        videos: 'Videos',
        audios: 'Audio',
      },
      filters: {
        type: 'Tipo de contenido',
        all: 'Todo',
        image: 'Imagen',
        video: 'Video',
        audio: 'Audio',
        source: 'Página de origen',
        sourceVG: 'Generación de video',
        sourceDH: 'Flujo de humano digital',
      },
      empty: {
        title: 'Aún no hay registros',
        hint: '¡Comienza a crear tu primera obra!',
      },
      meta: {
        size: 'Tamaño',
        duration: 'Duración',
        seconds: '{sec}s',
        noPrompt: 'Sin indicación',
        copyTitle: 'Copiar URL',
      },
      types: {
        unknown: 'Desconocido',
        image: 'Imagen',
        video: 'Video',
        audio: 'Audio',
        subtypes: {
          text_to_image: 'Texto a imagen',
          image_to_image: 'Imagen a imagen',
          image_upscale: 'Mejora de imagen',
          text_to_video: 'Texto a video',
          image_to_video: 'Imagen a video',
          digital_human_video: 'Video de humano digital',
          video_upscale: 'Mejora de video',
          video_enhance: 'Mejora de video',
          text_to_speech: 'Texto a voz',
          voice_clone: 'Clonación de voz',
          audio_enhance: 'Mejora de audio',
        },
      },
    },
    payment: {
      title: 'Gestión de pagos',
      subtitle: 'Administra el saldo de tu cuenta y transacciones',
      alerts: {
        enterValidAmount: 'Por favor ingresa una cantidad válida',
        createSessionFail: 'Error al crear sesión de pago',
        depositFail: 'Depósito fallido: {msg}',
        insufficient: 'Saldo insuficiente',
        withdrawSubmitted: '¡Solicitud de retiro enviada! Cantidad: ${amount}\nPor favor espera la revisión del administrador',
        withdrawFail: 'Retiro fallido: {msg}',
      },
      tabs: {
        deposit: 'Depositar',
        withdraw: 'Retirar',
      },
      form: {
        amount: 'Cantidad',
        paymentMethod: 'Método de pago',
        card: 'Tarjeta de crédito / débito',
        bank: 'Transferencia bancaria',
        processing: 'Procesando...',
        depositBtn: 'Depositar ${amount}',
        withdrawBtn: 'Retirar ${amount}',
        available: 'Disponible: ${amount}',
      },
    },
    referral: {
      title: 'Referidos y planes',
      subtitle: 'Comparte tu código de referido y gana un 10% de reembolso',
      alerts: {
        copied: '¡{label} copiado al portapapeles!',
      },
      codeCard: {
        yourCode: 'Tu código de referido',
        description: '¡Comparte tu código de referido y gana un 10% de reembolso en todas las compras realizadas por usuarios referidos!',
      },
      stats: {
        users: 'Usuarios referidos',
        earnings: 'Ganancias por referidos',
        cashback: 'Reembolso de referidos',
      },
      share: {
        title: 'Comparte tu referido',
        code: 'Tu código de referido',
        link: 'Enlace de referido',
      },
      how: {
        title: 'Cómo funciona',
        step1Title: 'Comparte tu código',
        step1Desc: 'Envía tu código de referido o enlace a amigos',
        step2Title: 'Ellos se registran',
        step2Desc: 'Nuevos usuarios se registran usando tu código de referido',
        step3Title: 'Gana reembolso',
        step3Desc: 'Obtén un 10% de reembolso en sus compras automáticamente',
      },
    },
    superIP: {
      title: 'Super IP',
      subtitle: 'Crea tu propio personaje digital',
      nav: {
        chooseCharacter: 'Elegir personaje',
        uploadCharacter: 'Cargar personaje',
        chooseVoice: 'Elegir voz',
        uploadVoice: 'Cargar voz',
        generateVideoTab: 'Generar video',
        videoStatus: 'Estado del video',
        send: 'Enviar',
        quickSendTitle: 'Generar video rápidamente con imagen y audio actuales',
      },
      work: {
        chooseImage: 'Elegir imagen',
        openGallery: 'Abrir galería',
        inputPrompt: 'Ingresar indicación',
        promptPlaceholder: 'Describe el personaje que quieres...',
        clear: 'Limpiar',
        generateImage: 'Generar imagen',
        generatingImage: 'Generando...',
        result: 'Resultado',
        resultPlaceholderImage: 'La imagen generada aparecerá aquí',
        history: 'Historial',
        historyEmpty: 'Aún no hay historial',
        waveform: 'Forma de onda',
        analyze: 'Analizando...',
        generate: 'Coincidir',
        selectVoice: 'Seleccionar voz',
        clearVoice: 'Limpiar voz',
        inputText: 'Ingresar texto',
        inputTextPlaceholder: 'Ingresa texto para convertir a voz...',
        generateVoice: 'Generar',
        generatingVoice: 'Generando...',
        resultPlaceholderAudio: 'El audio generado aparecerá aquí',
        playAudio: 'Reproducir audio',
        generateTabPrompt: 'Ingresa una indicación describiendo el video que quieres...',
        generatingVideo: 'Generando video...',
        playVideo: 'Reproducir',
        download: 'Descargar',
        resultPlaceholderVideo: 'El video generado aparecerá aquí',
      },
      sections: {
        voiceClone: 'Clon de voz',
      },
      clone: {
        selectFile: 'Seleccionar archivo',
        settingsTitle: 'Configurar Voice ID',
        customVoiceId: 'Voice ID personalizado',
        autoNamePlaceholder: 'Déjalo vacío para generar automáticamente',
        supportFormats: 'Compatible con',
      },
      dialogs: {
        galleryTitle: 'Seleccionar imagen - Historial',
        loading: 'Cargando...',
        saving: 'Guardando...',
        empty: 'Sin historial de imágenes',
        delete: 'Eliminar',
        confirmDelete: '¿Estás seguro de que deseas eliminar esta imagen?',
        selectVoiceTitle: 'Seleccionar voz',
        systemVoices: 'Voces del sistema',
        generatedVoices: 'Voces generadas',
        customVoices: 'Voces personalizadas',
  cloneVoices: 'Voces clonadas',
        unnamedVoice: 'Voz sin nombre',
        analyzeTitle: 'Generar prueba',
        analyzePrompt: 'Indicación (para análisis)',
        trialText: 'Texto de prueba',
        resetTrialText: 'Restablecer texto de prueba',
        refreshAnalyze: 'Actualizar análisis',
        generateTrialProcessing: 'Generando prueba...',
        generateTrial: 'Generar audio de prueba',
      },
      placeholders: {
        result: 'RESULTADO',
      },
      alerts: {
        imageGenFailNoUrl: 'Generación fallida, no se devolvió URL de imagen',
        imageGenFail: 'Generación de imagen fallida: {msg}',
        needCharacterImage: 'Por favor carga o selecciona una imagen de personaje primero',
        analyzeInvalid: 'Resultado de análisis inválido',
        analyzeFail: 'Análisis fallido, por favor verifica tu red o servidor',
        needAnalyzeOrPrompt: 'Por favor analiza la imagen del personaje o proporciona una indicación de voz primero',
        needTrialText: 'Por favor ingresa texto de prueba',
        trialFail: 'Generación de prueba fallida',
        playFail: 'Reproducción fallida',
        needVoiceId: 'Por favor selecciona una voz o genera una prueba para obtener un voice_id utilizable',
        audioUploadFail: 'Carga de audio fallida: {msg}',
        imageUploadFail: 'Carga de imagen fallida: {msg}',
        videoGenNoUrl: 'Generación de video fallida o no se devolvió URL de video',
        genFail: 'Generación fallida',
      },
    },
    subscriptionPage: {
      title: 'Planes de suscripción',
      compareButton: 'Ver comparación completa',
      statusLabel: 'Estado actual:',
      freeSuffix: 'Free',
      planSuffix: 'Plan',
      currentPlanCardLabel: 'Plan actual',
      monthlyCreditsLabel: 'Créditos mensuales',
      placeholderLabel: 'Placeholder',
      manageButton: 'Administrar suscripción',
      usedLabel: 'Usado',
      remainingLabelPrefix: 'Créditos restantes este mes:',
      buyExtraCredits: 'Comprar paquete extra de créditos →',
      upgradePrefix: 'Mejorar a',
      creatorName: 'Creator',
      businessName: 'Business',
      enterpriseName: 'Enterprise',
      upgradeBenefitsIntro: 'Obtén más funciones y mayor cuota mensual.',
      benefitMonthlyCreditsSuffix: 'créditos/mes',
      benefitTeamCollaboration: 'Colaboración de equipo',
      benefitEnterpriseCustom: 'Cuotas personalizadas y soporte dedicado',
      upgradeButton: 'Mejorar',
      highestTitle: 'Máximo nivel alcanzado',
      highestDescription: 'Tu plan es Enterprise, todas las funciones están desbloqueadas.',
      highestContact: 'Para soluciones personalizadas contacta ventas.',
      expiryPrefix: 'Fecha de expiración:',
      expiryFree: 'Ilimitado',
      expiryCustom: 'Personalizado',
      expiryUnknown: 'Desconocido',
      errors: {
        notLoggedIn: 'No has iniciado sesión, no se puede obtener la información',
        fetchFailed: 'Error al obtener información del usuario',
      },
    },
  },
  ja: {
    subscriptionPage: {
      title: 'サブスクリプション',
      compareButton: '特典の全比較を見る',
      statusLabel: '現在のステータス:',
      freeSuffix: 'フリー',
      planSuffix: 'プラン',
      currentPlanCardLabel: '現在のプラン',
      monthlyCreditsLabel: '月間クレジット',
      placeholderLabel: 'プレースホルダー',
      manageButton: 'サブスクリプションを管理',
      usedLabel: '使用済み',
      remainingLabelPrefix: '今月の残りクレジット:',
      buyExtraCredits: '追加クレジットを購入 →',
      upgradePrefix: 'アップグレード先',
      creatorName: 'クリエイター',
      businessName: 'ビジネス',
      enterpriseName: 'エンタープライズ',
      upgradeBenefitsIntro: 'より多くの機能と月間クレジットが利用できます。',
      benefitMonthlyCreditsSuffix: 'クレジット/月',
      benefitTeamCollaboration: 'チームコラボレーション機能',
      benefitEnterpriseCustom: 'カスタム配分と専任サポート',
      upgradeButton: 'アップグレード',
      highestTitle: 'すでに最上位プランです',
      highestDescription: '現在はエンタープライズです。すべての機能が利用可能です。',
      highestContact: 'カスタムソリューションは営業までお問い合わせください。',
      expiryPrefix: '有効期限:',
      expiryFree: '無期限',
      expiryCustom: 'カスタム',
      expiryUnknown: '不明',
      errors: {
        notLoggedIn: '未ログインのため、購読情報を取得できません',
        fetchFailed: 'ユーザー情報の取得に失敗しました',
      },
    },
    sidebar: {
      workspace: 'ワークスペース',
      history: '生成履歴',
      section: {
        replicator: 'バズ動画復刻',
        commerce: '商品紹介動画',
        finance: '財務と成長',
        account: 'アカウント',
      },
      scripts: 'スクリプト',
      digitalExpert: 'デジタルエキスパート',
      sora: 'HyperSell',
      superIP: 'Super IP',
      partner: 'アフィリエイト',
      subscription: 'サブスクリプション',
      credits: 'クレジット',
      payment: '支払い',
      referral: '紹介とプラン',
      noEmail: 'メール未登録',
      logout: 'ログアウト',
      userMenu: {
        toggleLang: '言語を切り替える',
        upgrade: 'アップグレード',
        credits: 'クレジット',
        freeplan: 'Free プラン',
      },
    },
    // Workspace page (Japanese)
    workspace: {
      title: 'ワークスペース',
      cards: {
        generateTitle: '生成スタジオ',
        generateDesc: '画像・動画・音声の生成ツールをまとめて利用',
        analyzeTitle: 'バズ分析',
        analyzeDesc: '動画リンクで台本やプロンプトを抽出して研究',
        digitalTitle: 'デジタルエキスパート',
        digitalDesc: '専門家エージェントで作業効率を最大化',
      },
      poweredBy: 'VGOT が提供',
    },
    // Video Analysis (Japanese)
    videoAnalysis: {
        title: '数秒で動画インサイトを取得',
        subtitle: '分析対象を選び、動画リンクを貼り付けて、すぐに活用できる洞察を得ましょう',
        uploadTitle: 'ドラッグまたはクリックしてアップロード',
        uploadImageTitle: '画像をドラッグまたはクリックしてアップロード',
        uploadHint: 'MP4・MOV などに対応、推奨解像度は 720P 以上',
        chooseVideo: '動画を選択',
        clearFile: 'クリア',
        securityHint: '動画はプロンプト抽出のためのみ、サーバーに安全にアップロードされます',
  urlLabel: 'または動画リンクを貼り付け（TikTok 対応）',
  urlLabelBasic: 'または動画リンクを貼り付け',
        placeholder: 'https://www.tiktok.com/@nickname/video/7548476830056025374',
        optionsTitle: '分析オプション',
  optionScriptTitle: '音声コピー抽出',
          optionScriptDesc: '動画から音声の台本文字起こしを抽出',
          optionSceneTitle: 'プロンプト逆生成',
          optionSceneDesc: '動画内容を解析し、プロンプトをワンクリックで推定',
          optionRewriteTitle: 'バズるコピー',
          optionRewriteDesc: '商品情報と商品画像からワンクリックでバズるコピーを生成',
          needUrl: '動画 URL を入力してください',
          extractFail: '抽出に失敗しました。もう一度お試しください',
          needInput: '動画をアップロードするか、動画 URL を入力してください',
          needRewriteText: '書き換えるテキストを入力してください',
          rewriteFail: '書き換えに失敗しました。もう一度お試しください',
        },
      },

    // History page (Japanese)
    history: {
        title: '生成履歴',
        subtitle: '生成した画像・動画・音声をすべて確認',
        loading: '履歴を読み込み中…',
        stats: {
          total: '合計',
          images: '画像',
          videos: '動画',
          audios: '音声',
        },
        filters: {
          type: '種類',
          all: 'すべて',
          image: '画像',
          video: '動画',
          audio: '音声',
  sourcedH: 'データソース',
  // Some UIs reference sourceVG/sourceDH keys; provide aliases to avoid raw keys
  sourceVG: 'データソース',
  sourceDH: 'データソース',
        types: {
          image: '画像生成',
          video: '動画生成',
          audio: '音声生成',
          subtypes: {
            image_to_video: '画像 → 動画',
          video_to_image: '動画 → 画像',
          text_to_image: 'テキスト → 画像',
          text_to_video: 'テキスト → 動画',
          }
        },
        meta: {
          size: 'サイズ',
          duration: '長さ',
          seconds: '秒',
        },
        actions: {
          download: 'ダウンロード',
          delete: '削除',
        }
      },

  // Super IP work/nav (Japanese)
  superIP: {
    title: 'Super IP',
        subtitle: 'あなた専用のデジタルキャラクターを作成',
        sections: {
          voiceClone: 'ボイスクローン',
        },
        nav: {
          chooseCharacter: 'キャラクター選択',
          uploadCharacter: 'キャラアップ',
          chooseVoice: '音色選択',
          uploadVoice: '音声アップロード',
          generateVideoTab: '動画生成',
          videoStatus: '動画生成',
          videos: '動画生成',
          send: '送信',
        },
        work: {
          chooseImage: 'キャラクター画像を選択',
          openGallery: 'ギャラリーを開く',
          inputPrompt: 'プロンプト入力',
          promptPlaceholder: '生成したい内容を入力…',
          aspectRatio: 'アスペクト比',
          clear: 'クリア',
          generateImage: '生成',
          generatingImage: '生成中…',
          result: '結果',
          resultPlaceholderImage: '生成された画像はここに表示されます',
          history: '履歴',
          historyEmpty: '履歴はまだありません',
          waveform: '音声波形',
          analyze: '分析中…',
          generate: '一致',
          selectVoice: '音色を選択',
          clearVoice: '音色をクリア',
          inputText: 'テキスト入力',
          inputTextPlaceholder: '音声に変換したいテキストを入力…',
          generateVoice: '生成',
          generatingVoice: '生成中…',
          resultPlaceholderAudio: '生成された音声はここに表示されます',
          playAudio: '音声を再生',
          generateTabPrompt: '動画生成用のプロンプトを入力してください…',
          generatingVideo: '動画生成中…',
          playVideo: '動画を再生',
          download: 'ダウンロード',
          resultPlaceholderVideo: '生成された動画はここに表示されます',
        },
        clone: {
          selectFile: 'ファイルを選択',
          settingsTitle: 'Voice ID を設定',
          customVoiceId: 'カスタム Voice ID',
          autoNamePlaceholder: '空欄の場合は自動生成',
          supportFormats: '対応',
        },
        dialogs: {
          selectVoiceTitle: '音色を選択',
          systemVoices: 'システム音色',
          generatedVoices: '生成音色',
          customVoices: 'カスタム音色',
    cloneVoices: 'クローン音色',
          unnamedVoice: '名称未設定の音色',
          analyzeTitle: '試聴を生成',
          analyzePrompt: 'プロンプト（分析用）',
          trialText: '試聴テキスト',
          resetTrialText: '試聴テキストをリセット',
          refreshAnalyze: '分析を更新',
          generateTrialProcessing: '試聴生成中…',
          generateTrial: '試聴音声を生成',
          loading: '読み込み中…',
          saving: '保存中…',
          delete: '削除',
          confirmDelete: 'この画像を削除しますか？',
        },
        placeholders: {
          result: '結果',
        },
        alerts: {
          audioUploadFail: '音声のアップロードに失敗しました: {msg}',
          needVoiceId: '音色を選択するか試聴を生成して、使用可能な voice_id を取得してください',
        },
      },
    },
};

// Merge landing page translations
const mergedMessages = {
  zh: {
    ...messages.zh,
    ...landingTranslations['zh-CN'],
  },
  en: {
    ...messages.en,
    ...landingTranslations.en,
  },
  'zh-TW': {
    ...messages['zh-TW'],
    ...landingTranslations['zh-TW'],
  },
  es: {
    ...messages.es,
    ...landingTranslations.es,
  },
  ja: {
    ...messages.ja,
    ...landingTranslations.ja,
  },
};

export default mergedMessages;